<div class="settings-container">
  <div class="settings-list">
    <!-- Profile -->
    <button class="setting-item" [appTourAnchor]="'settings.profileTile'" (click)="toggleProfileOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">person_outline</mat-icon>
        <span>Profile</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Default sharing -->
    <button class="setting-item" [appTourAnchor]="'settings.sharingTile'" (click)="toggleDefaultSharingOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">visibility</mat-icon>
        <span>Default sharing</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Default crew settings -->
    <button class="setting-item" [appTourAnchor]="'settings.crewTile'" (click)="toggleCrewOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">people_outline</mat-icon>
        <span>Default crew settings</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Password and security -->
    <button class="setting-item" [appTourAnchor]="'settings.passwordTile'" (click)="toggleSecurityOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">lock_outline</mat-icon>
        <span>Password and security</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Blocked users -->
    <button class="setting-item" (click)="toggleBlockedUsersOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">block</mat-icon>
        <span>Blocked users</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Units of measurement -->
    <button class="setting-item" [appTourAnchor]="'settings.unitsTile'" (click)="toggleUnitsOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">straighten</mat-icon>
        <span>Units of measurement</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Position format -->
    <button class="setting-item" (click)="togglePositionFormatOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">gps_fixed</mat-icon>
        <span>Position format</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Map settings -->
    <button class="setting-item" [appTourAnchor]="'settings.mapTile'" (click)="toggleMapSettingsOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">explore</mat-icon>
        <span>Map settings</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Automated Trip Logging -->
    <button class="setting-item" (click)="toggleAutoTripsOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">auto_mode</mat-icon>
        <span>Automated Trip Logging</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Water Drop settings (admin only) -->
    <button class="setting-item" *ngIf="isAdmin && isWaterDropUnlocked" (click)="toggleWaterDropOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">water_drop</mat-icon>
        <span>Water Drop settings</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Admin settings (if admin) -->
    <button class="setting-item" *ngIf="isAdmin" (click)="toggleAdminSettingsOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">admin_panel_settings</mat-icon>
        <span>Admin settings</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Offline mode -->
    <button class="setting-item" [appTourAnchor]="'settings.offlineTile'" (click)="toggleOfflineOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">signal_cellular_off</mat-icon>
        <span>Offline mode</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Support -->
    <button class="setting-item" [appTourAnchor]="'settings.supportTile'" (click)="toggleSupportOverlay(true)">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting">help_outline</mat-icon>
        <span>Support</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </button>

    <!-- Delete Account -->
    <button class="setting-item delete-item" (click)="showDeleteConfirm = true">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting delete-icon">delete_outline</mat-icon>
        <span class="delete-text">Delete Account</span>
      </div>
      <mat-icon class="chevron-icon delete-icon">chevron_right</mat-icon>
    </button>

    <!-- Logout -->
    <button class="setting-item logout-item" (click)="showLogoutConfirm = true">
      <div class="left-content">
        <mat-icon class="icon mat-icon-setting logout-icon">logout</mat-icon>
        <span class="logout-text">Logout</span>
      </div>
      <mat-icon class="chevron-icon logout-icon">chevron_right</mat-icon>
    </button>
  </div>
</div>

<!-- Delete Account Confirm Modal -->
<div class="confirm-overlay" *ngIf="showDeleteConfirm" (click)="showDeleteConfirm = false">
  <div class="confirm-modal" (click)="$event.stopPropagation()">
    <div class="confirm-icon danger">
      <img src="assets/home/profile/deleteicon.svg" alt="Delete" />
    </div>
    <h3 class="confirm-title">Delete Account</h3>
    <p class="confirm-message">Are you sure you want to permanently delete your account? This action cannot be undone.</p>
    <div class="confirm-actions">
      <button class="confirm-btn cancel-btn" (click)="showDeleteConfirm = false">Cancel</button>
      <button class="confirm-btn danger-btn" (click)="confirmDeleteAccount()">Delete</button>
    </div>
  </div>
</div>

<!-- Logout Confirm Modal -->
<div class="confirm-overlay" *ngIf="showLogoutConfirm" (click)="showLogoutConfirm = false">
  <div class="confirm-modal" (click)="$event.stopPropagation()">
    <div class="confirm-icon logout">
      <img src="https://storybook.predigle.com/assets/logout-light.svg" alt="Logout" />
    </div>
    <h3 class="confirm-title">Log Out</h3>
    <p class="confirm-message">Are you sure you want to log out of your account?</p>
    <div class="confirm-actions">
      <button class="confirm-btn cancel-btn" (click)="showLogoutConfirm = false">Cancel</button>
      <button class="confirm-btn logout-btn" (click)="logout()">Log Out</button>
    </div>
  </div>
</div>

<!-- Profile Information Overlay -->
<div class="bottom-sheet-overlay" *ngIf="showProfileOverlay" (click)="toggleProfileOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleProfileOverlay(false)"></app-back-button>

        <h2 class="title">Profile Information</h2>

        <app-confirm-button [appTourAnchor]="'profile.save'" ariaLabel="Save profile" [loading]="isLoading" [disabled]="isLoading"
          (clicked)="saveProfile()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- Profile Image Section -->
      <div class="profile-pic-section">
        <div class="pic-uploader" [appTourAnchor]="'profile.photo'" (click)="picInput.click()">
          <img [src]="
              profileData.image_url || 'assets/home/profile/default-avatar.svg'
            " class="pic-preview" alt="Avatar" />
          <app-camera-button ariaLabel="Update profile photo" (clicked)="picInput.click()"></app-camera-button>
          <input type="file" #picInput hidden (change)="onImageSelected($event)" accept="image/*" />
        </div>
      </div>

      <div class="form-container">
        <p class="section-label">Profile</p>

        <div class="form-group" [appTourAnchor]="'profile.firstName'">
          <label>First Name</label>
          <input type="text" [(ngModel)]="profileData.first_name" name="first_name" placeholder="First Name" />
        </div>

        <div class="form-group">
          <label>Last Name</label>
          <input type="text" [(ngModel)]="profileData.last_name" name="last_name" placeholder="Last Name" />
        </div>

        <div class="form-group" [appTourAnchor]="'profile.email'">
          <label>Email</label>
          <input type="email" [(ngModel)]="profileData.email_address.email_address" name="email" placeholder="Email" />
        </div>

        <div class="form-group" [appTourAnchor]="'profile.phone'">
          <label>Phone</label>
          <input type="text" [(ngModel)]="profileData.phone_address.phone_number" name="phone" placeholder="Phone" />
        </div>

        <div class="toggle-row" [appTourAnchor]="'profile.allowContact'">
          <div class="toggle-info">
            <span class="toggle-label">Allow dockmates to see your contact info</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="profileData.allow_contact" name="allow_friends" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div class="overlay-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
</div>

<!-- Units of Measurement Overlay -->
<div class="bottom-sheet-overlay units-overlay" *ngIf="showUnitsOverlay" (click)="toggleUnitsOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleUnitsOverlay(false)"></app-back-button>
        <h2 class="title">Units of Measurement</h2>
        <app-confirm-button [appTourAnchor]="'units.save'" ariaLabel="Save units" [loading]="isLoading" [disabled]="isLoading"
          (clicked)="saveUnits()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- GPS Type -->
      <div class="unit-section" [appTourAnchor]="'units.gps'">
        <p class="section-label">GPS Type</p>
        <div class="unit-options">
          <button class="unit-option" (click)="unitsData.settings.gps_type = 'GPS'">
            <div class="radio-circle"
              [class.selected]="!unitsData.settings.gps_type || unitsData.settings.gps_type.toUpperCase() === 'GPS'">
            </div>
            <span>GPS</span>
          </button>
          <button class="unit-option disabled">
            <div class="radio-circle disabled-circle"></div>
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <span style="color: #999;">LORAN</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Distance Unit -->
      <div class="unit-section" [appTourAnchor]="'units.distance'">
        <p class="section-label">Distance Unit</p>
        <div class="unit-options">
          <button class="unit-option" (click)="unitsData.settings.distance_unit = 'nautical'">
            <div class="radio-circle" [class.selected]="unitsData.settings.distance_unit === 'nautical'"></div>
            <span>Nautical Miles</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.distance_unit = 'meters'">
            <div class="radio-circle" [class.selected]="unitsData.settings.distance_unit === 'meters'"></div>
            <span>Meters</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.distance_unit = 'kilometers'">
            <div class="radio-circle" [class.selected]="
                unitsData.settings.distance_unit === 'kilometers'
              "></div>
            <span>Kilometers</span>
          </button>
        </div>
      </div>

      <!-- Speed Unit -->
      <div class="unit-section" [appTourAnchor]="'units.speed'">
        <p class="section-label">Speed Unit</p>
        <div class="unit-options">
          <button class="unit-option" (click)="unitsData.settings.speed_unit = 'knots'">
            <div class="radio-circle" [class.selected]="unitsData.settings.speed_unit === 'knots'"></div>
            <span>Knots</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.speed_unit = 'mph'">
            <div class="radio-circle" [class.selected]="unitsData.settings.speed_unit === 'mph'"></div>
            <span>MPH</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.speed_unit = 'kmh'">
            <div class="radio-circle" [class.selected]="unitsData.settings.speed_unit === 'kmh'"></div>
            <span>KM/H</span>
          </button>
        </div>
      </div>

      <!-- Temperature Unit -->
      <div class="unit-section" [appTourAnchor]="'units.temperature'">
        <p class="section-label">Temperature Unit</p>
        <div class="unit-options">
          <button class="unit-option" (click)="unitsData.settings.temperature_unit = 'celsius'">
            <div class="radio-circle" [class.selected]="
                unitsData.settings.temperature_unit === 'celsius'
              "></div>
            <span>Celsius</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.temperature_unit = 'fahrenheit'">
            <div class="radio-circle" [class.selected]="
                unitsData.settings.temperature_unit === 'fahrenheit'
              "></div>
            <span>Fahrenheit</span>
          </button>
        </div>
      </div>

      <!-- Depth Unit -->
      <div class="unit-section" [appTourAnchor]="'units.depth'">
        <p class="section-label">Depth Unit</p>
        <div class="unit-options">
          <button class="unit-option" (click)="unitsData.settings.depth_unit = 'feet'">
            <div class="radio-circle" [class.selected]="unitsData.settings.depth_unit === 'feet'"></div>
            <span>Feet</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.depth_unit = 'fathoms'">
            <div class="radio-circle" [class.selected]="unitsData.settings.depth_unit === 'fathoms'"></div>
            <span>Fathoms</span>
          </button>
          <button class="unit-option" (click)="unitsData.settings.depth_unit = 'meters'">
            <div class="radio-circle" [class.selected]="unitsData.settings.depth_unit === 'meters'"></div>
            <span>Meters</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div class="overlay-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
</div>

<!-- Map Settings Overlay (mirrors MapOrientationSheet + MapSkinPicker) -->
<div class="bottom-sheet-overlay map-settings-overlay" *ngIf="showMapSettingsOverlay"
  (click)="toggleMapSettingsOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleMapSettingsOverlay(false)"></app-back-button>
        <h2 class="title">Map Settings</h2>
        <app-confirm-button [appTourAnchor]="'map.save'" ariaLabel="Save map settings" [loading]="isLoading" [disabled]="isLoading"
          (clicked)="saveMapSettings()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- MAP SKIN SECTION -->
      <div class="settings-group" [appTourAnchor]="'map.skin'">
        <p class="section-label">Map Skin</p>
        <div class="skins-row">
          <div class="skin-card" *ngFor="let skin of classicSkins" [class.selected]="selectedSkinId === skin.id" (click)="selectMapSkin(skin.id)">
            <div class="skin-thumb-wrap">
              <img [src]="skin.thumbnail" [alt]="skin.label" class="skin-thumb" />
              <div class="skin-selected-badge" *ngIf="selectedSkinId === skin.id">
                <mat-icon>check</mat-icon>
              </div>
            </div>
            <span class="skin-label">{{ skin.label }}</span>
          </div>
        </div>

        <!-- DEPTH SKINS -->
        <p class="section-label sub-heading">Depth</p>
        <div class="skins-row">
          <div class="skin-card" *ngFor="let skin of depthSkins" [class.selected]="selectedSkinId === skin.id" (click)="selectMapSkin(skin.id)">
            <div class="skin-thumb-wrap">
              <img [src]="skin.thumbnail" [alt]="skin.label" class="skin-thumb" />
              <div class="skin-selected-badge" *ngIf="selectedSkinId === skin.id">
                <mat-icon>check</mat-icon>
              </div>
            </div>
            <span class="skin-label">{{ skin.label }}</span>
          </div>
        </div>

        <div class="skin-description-line">
          <strong>{{ getSelectedSkin().label }} — </strong>
          <span>{{ getSelectedSkin().description }}</span>
        </div>
        <p class="attribution-note">© MapTiler © OpenStreetMap contributors</p>
      </div>

      <!-- ORIENTATION MODE -->
      <div class="settings-group" [appTourAnchor]="'map.orientation'">
        <p class="section-label">Orientation Mode</p>
        <div class="options-list orientation-options-list">
          <div class="option-row orientation-item" (click)="selectMapOrientation('normal')">
            <div class="option-text">
              <span class="option-title">Normal</span>
              <span class="option-sub">Rotation allowed &mdash; map moves freely</span>
            </div>
            <div class="radio-circle" [class.selected]="unitsData.settings.map_orientation?.mode === 'normal'"></div>
          </div>

          <div class="option-row orientation-item" (click)="selectMapOrientation('north_up')">
            <div class="option-text">
              <span class="option-title">North Up</span>
              <span class="option-sub">Map is locked facing north &mdash; lock button enabled</span>
            </div>
            <div class="radio-circle" [class.selected]="unitsData.settings.map_orientation?.mode === 'north_up'"></div>
          </div>

          <div class="option-row orientation-item disabled">
            <div class="option-text">
              <span class="option-title" style="color: #999;">Course Up</span>
              <span class="option-sub" style="color: #ccc;">Coming soon</span>
            </div>
            <div class="radio-circle disabled-circle"></div>
          </div>
        </div>
      </div>

      <!-- CONTROLS -->
      <div class="settings-group" [appTourAnchor]="'map.pointClick'">
        <p class="section-label">Controls</p>
        <div class="toggle-card">
          <div class="toggle-info">
            <span class="toggle-title">Tap map to drop waypoint</span>
            <span class="toggle-sub">Tap anywhere on the chart to quickly drop a waypoint.</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="pointClickEnabled" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- TRACKLINES -->
      <div class="settings-group" [appTourAnchor]="'map.tracklines'">
        <p class="section-label">Tracklines</p>
        <div class="toggle-card">
          <div class="toggle-info">
            <span class="toggle-title">Show tracklines</span>
            <span class="toggle-sub">Display your recorded boat paths on the map.</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="enableTracklines" />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-card">
          <div class="toggle-info">
            <span class="toggle-title">Fade older tracklines</span>
            <span class="toggle-sub">Gradually fade paths from previous trips.</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="fadeOldTracklines" [disabled]="!enableTracklines" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Default Crew Settings Overlay (mirrors DefaultCrewSettingsSheet) -->
<div class="bottom-sheet-overlay" *ngIf="showCrewOverlay" (click)="toggleCrewOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleCrewOverlay(false)"></app-back-button>
        <h2 class="title">Default Crew</h2>
        <app-confirm-button [appTourAnchor]="'crew.save'" ariaLabel="Save crew" [loading]="isSavingCrew" [disabled]="isSavingCrew"
          (clicked)="saveDefaultCrew()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-subtitle">
        Select dockmates who are automatically added as crew members to your trips.
      </p>

      <div class="search-box" [appTourAnchor]="'crew.search'">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" placeholder="Search Dockmates" [(ngModel)]="crewSearchQuery" />
      </div>

      <div class="crew-list" [appTourAnchor]="'crew.list'">
        <div class="crew-item" *ngFor="let mate of filteredCrewDockmates" (click)="toggleCrewMember(mate.user?.user_id || mate.user?._id || mate.id)">
          <div class="checkbox" [class.checked]="isCrewSelected(mate.user?.user_id || mate.user?._id || mate.id)"></div>
          <img *ngIf="mate.user?.image_url || mate.image_url" [src]="mate.user?.image_url || mate.image_url" class="avatar" alt="Avatar" />
          <div *ngIf="!mate.user?.image_url && !mate.image_url" class="avatar-fallback">
            {{ getInitials(mate.user?.name || mate.name) }}
          </div>
          <div class="crew-info">
            <span class="crew-name">{{ mate.user?.name || mate.name }}</span>
            <span class="crew-vessel">{{ mate.vessel_name || 'No Vessel' }}</span>
          </div>
        </div>

        <div class="empty-list" *ngIf="filteredCrewDockmates.length === 0">
          <p>No dockmates found</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Blocked Users Overlay (mirrors BlockedUsersScreen) -->
<div class="bottom-sheet-overlay" *ngIf="showBlockedUsersOverlay" (click)="toggleBlockedUsersOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleBlockedUsersOverlay(false)"></app-back-button>
        <h2 class="title">Blocked Users</h2>
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <div class="blocked-users-list" *ngIf="!isLoadingBlockedUsers && blockedUsers.length > 0">
        <div class="blocked-user-row" *ngFor="let user of blockedUsers">
          <div class="user-meta">
            <img *ngIf="user.avatar_url || user.image_url || user.profile_photo" [src]="user.avatar_url || user.image_url || user.profile_photo" class="avatar" alt="Avatar" />
            <div *ngIf="!(user.avatar_url || user.image_url || user.profile_photo)" class="avatar-fallback">
              {{ getInitials(user.display_name || user.name) || 'C' }}
            </div>
            <div class="user-text">
              <span class="user-name">{{ user.display_name || user.name || 'Blocked Captain' }}</span>
              <span class="user-sub" *ngIf="user.created_at">Blocked {{ user.created_at | date:'mediumDate' }}</span>
            </div>
          </div>

          <button type="button" class="unblock-btn" [disabled]="isUnblockingId === (user.user_id || user.id || user._id)" (click)="unblockUser(user)">
            {{ isUnblockingId === (user.user_id || user.id || user._id) ? 'Unblocking...' : 'Unblock' }}
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="!isLoadingBlockedUsers && blockedUsers.length === 0">
        <div class="empty-icon-wrap">
          <mat-icon class="large-empty-icon">block</mat-icon>
        </div>
        <h3>No Blocked Users</h3>
        <p>Captains you block will appear here. They won't be able to message you or see your content.</p>
      </div>

      <!-- Loading State -->
      <div class="modal-loading-state" *ngIf="isLoadingBlockedUsers">
        <div class="spinner"></div>
        <p class="loading-text">Loading blocked users...</p>
      </div>
    </div>
  </div>
</div>

<!-- Position Format Overlay (mirrors GpsFormatSheet) -->
<div class="bottom-sheet-overlay" *ngIf="showPositionFormatOverlay" (click)="togglePositionFormatOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="togglePositionFormatOverlay(false)"></app-back-button>
        <h2 class="title">Position Format</h2>
        <app-confirm-button ariaLabel="Save position format" (clicked)="savePositionFormat()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-subtitle">
        How positions are shown throughout the app. Saved on this device only.
      </p>

      <div class="options-list">
        <!-- DMM -->
        <div class="option-row" (click)="selectCoordinateFormat('ddm')">
          <div class="option-text">
            <span class="option-title">DMM</span>
            <span class="option-sub">Degrees + decimal minutes — 25° 45.300' N</span>
          </div>
          <div class="radio-circle" [class.selected]="selectedCoordinateFormat === 'ddm'"></div>
        </div>

        <!-- DMS -->
        <div class="option-row" (click)="selectCoordinateFormat('dms')">
          <div class="option-text">
            <span class="option-title">DMS</span>
            <span class="option-sub">Degrees / minutes / seconds — 25° 45' 18.0" N</span>
          </div>
          <div class="radio-circle" [class.selected]="selectedCoordinateFormat === 'dms'"></div>
        </div>

        <!-- LORAN -->
        <div class="option-row" (click)="selectCoordinateFormat('loran')">
          <div class="option-text">
            <span class="option-title">LORAN</span>
            <span class="option-sub">Time differences — 9960-X 26843.2</span>
          </div>
          <div class="radio-circle" [class.selected]="selectedCoordinateFormat === 'loran'"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Automated Trip Logging Overlay (mirrors AutomaticTripsSheet) -->
<div class="bottom-sheet-overlay" *ngIf="showAutoTripsOverlay" (click)="toggleAutoTripsOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleAutoTripsOverlay(false)"></app-back-button>
        <h2 class="title">Automated Trip Logging</h2>
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <!-- SUPPRESSION SECTION -->
      <div class="settings-group">
        <p class="section-label">SUPPRESSION</p>
        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <div class="title-with-icon">
              <mat-icon class="feature-icon">pause_circle_outline</mat-icon>
              <span class="toggle-title">Auto Start Suppression</span>
            </div>
            <span class="toggle-sub">
              Activated when you decline an auto start. While active the app will not send any auto starts.
              To re-enable, toggle this off or return to your slip location.
            </span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="autoStartSuppression" disabled />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- LOGGING METHOD SECTION -->
      <div class="settings-group">
        <p class="section-label">LOGGING METHOD</p>

        <!-- Data Bridge (pinned on) -->
        <div class="toggle-card disabled-card read-only-card">
          <div class="toggle-info">
            <div class="title-with-icon">
              <mat-icon class="feature-icon">settings_input_antenna</mat-icon>
              <span class="toggle-title">Data Bridge</span>
            </div>
            <span class="toggle-sub">Your paired Data Bridge detects trips on its own.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="true" disabled />
            <span class="slider round"></span>
          </label>
        </div>

        <!-- Phone (consent-gated) -->
        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <div class="title-with-icon">
              <mat-icon class="feature-icon">smartphone</mat-icon>
              <span class="toggle-title">Phone</span>
            </div>
            <span class="toggle-sub">
              Use the device location to detect when a trip starts using Vector Marine's intelligence. For use without a Data Bridge.
            </span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="autoTripPhone" disabled />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- Privacy Note -->
      <div class="privacy-notice-box">
        <mat-icon class="lock-icon">lock_outline</mat-icon>
        <p>
          Your location is only used to detect and record trips and shared via your own visibility settings.
          All other location data will not be recorded. Deselect to unenroll.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Water Drop Settings Overlay (mirrors WaterDropManageSheet, admin only) -->
<div class="bottom-sheet-overlay" *ngIf="showWaterDropOverlay && isAdmin" (click)="toggleWaterDropOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleWaterDropOverlay(false)"></app-back-button>
        <h2 class="title">Water Drop Settings</h2>
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-subtitle">Manage water drop real-time sharing and discovery preferences.</p>

      <div class="settings-group">
        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Enable Water Drop</span>
            <span class="toggle-sub">Share real-time positions, trips, and catches with authorized vessels.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="waterDropEnabled" disabled />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Water Drop Alerts</span>
            <span class="toggle-sub">Receive instant notifications when paired dockmates enter your area.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="waterDropAlerts" disabled />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Admin Settings Overlay (mirrors AdminSettingsSheet) -->
<div class="bottom-sheet-overlay" *ngIf="showAdminSettingsOverlay" (click)="toggleAdminSettingsOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleAdminSettingsOverlay(false)"></app-back-button>
        <h2 class="title">Admin Settings</h2>
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-subtitle">Diagnostic tooling and global feature gates for spectra.admin users.</p>

      <div class="settings-group">
        <p class="section-label">DIAGNOSTICS & RELAY</p>

        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Trip Caching</span>
            <span class="toggle-sub">Cache trip points locally in active session store.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="tripCachingEnabled" disabled />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Automatic Trips (Data Bridge Global)</span>
            <span class="toggle-sub">Master platform switch for Data Bridge trip auto-detection.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="adminDataBridgeGlobal" disabled />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Automatic Trips (Phone Global)</span>
            <span class="toggle-sub">Master platform switch for phone relay auto-detection.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="adminPhoneGlobal" disabled />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="toggle-card read-only-card">
          <div class="toggle-info">
            <span class="toggle-title">Master Water Drop</span>
            <span class="toggle-sub">Global entitlement gate for Water Drop.</span>
          </div>
          <label class="switch disabled read-only">
            <input type="checkbox" [checked]="adminWaterDropGlobal" disabled />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Offline Mode Overlay (mirrors OfflineOverviewSheet & OfflineDataSheet) -->
<div class="bottom-sheet-overlay" *ngIf="showOfflineOverlay" (click)="toggleOfflineOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleOfflineOverlay(false)"></app-back-button>
        <h2 class="title">Offline Mode</h2>
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-subtitle">
        Select how much data to download for use without an internet connection.
      </p>

      <div class="settings-group" [appTourAnchor]="'offline.range'">
        <p class="section-label">OFFLINE DATA RANGE</p>

        <div class="options-list">
          <div class="option-row" (click)="selectOfflineRange('24h')">
            <div class="option-text">
              <span class="option-title">Last 24 Hours</span>
              <span class="option-sub">Recent trips, catches, and local chart tiles</span>
            </div>
            <div class="radio-circle" [class.selected]="selectedOfflineRange === '24h'"></div>
          </div>

          <div class="option-row" (click)="selectOfflineRange('48h')">
            <div class="option-text">
              <span class="option-title">Last 48 Hours</span>
              <span class="option-sub">2 days of data and dockmate activity</span>
            </div>
            <div class="radio-circle" [class.selected]="selectedOfflineRange === '48h'"></div>
          </div>

          <div class="option-row" (click)="selectOfflineRange('7d')">
            <div class="option-text">
              <span class="option-title">Last 7 Days</span>
              <span class="option-sub">Full week of maritime records</span>
            </div>
            <div class="radio-circle" [class.selected]="selectedOfflineRange === '7d'"></div>
          </div>

          <div class="option-row" (click)="selectOfflineRange('30d')">
            <div class="option-text">
              <span class="option-title">Last 30 Days</span>
              <span class="option-sub">Comprehensive monthly cache</span>
            </div>
            <div class="radio-circle" [class.selected]="selectedOfflineRange === '30d'"></div>
          </div>

          <div class="option-row" (click)="selectOfflineRange('all')">
            <div class="option-text">
              <span class="option-title">All Offline Data</span>
              <span class="option-sub">All available historical waypoints and paths</span>
            </div>
            <div class="radio-circle" [class.selected]="selectedOfflineRange === 'all'"></div>
          </div>
        </div>
      </div>

      <!-- Download Action -->
      <div class="offline-action-wrap">
        <div class="progress-bar-wrap" *ngIf="isDownloadingOffline">
          <div class="progress-bar-fill" [style.width.%]="offlineDownloadProgress"></div>
        </div>
        <button type="button" class="download-offline-btn" [disabled]="isDownloadingOffline" (click)="startOfflineDownload()">
          <mat-icon class="btn-icon">cloud_download</mat-icon>
          <span>{{ isDownloadingOffline ? 'Downloading offline data...' : 'Download Offline Data' }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Default Sharing Overlay -->
<div class="bottom-sheet-overlay default-sharing-overlay" *ngIf="showDefaultSharingOverlay"
  (click)="toggleDefaultSharingOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="drag-handle"></div>
      <div class="header-actions">
        <app-exit-button class="exit-btn-overlay" ariaLabel="Back to settings"
            (clicked)="toggleDefaultSharingOverlay(false)"></app-exit-button>
        <h2 class="title" style="font-size: 17px">Visibility</h2>
        <app-confirm-button [appTourAnchor]="'sharing.apply'" ariaLabel="Save default sharing" [loading]="isLoading" [disabled]="isLoading"
          (clicked)="saveDefaultSharing()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="section-label" style="text-align: left; font-weight: 600; font-size: 14px;">Permissions</p>

      <div style="display: flex; flex-direction: column; gap: 2px;">
        <span style="text-align: left; font-weight: 400; font-size: 13px;color: #999;">Privacy</span>
      </div>
      <div class="privacy-options-list">
        <!-- Everyone -->
        <div class="privacy-item" [appTourAnchor]="'sharing.everyone'" (click)="unitsData.settings.privacy.default_visibility = 0">
          <div class="item-left">
            <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
              </svg>
            </div>
            <div class="item-text">
              <span class="main">The Water (Everyone)</span>
              <span class="sub">Anyone else on Vector can view this waypoint in feed or search.</span>
            </div>
          </div>
          <div class="radio-circle" [class.selected]="unitsData.settings.privacy.default_visibility == 0"></div>
        </div>

        <!-- Private -->
        <div class="privacy-item" [appTourAnchor]="'sharing.private'" (click)="unitsData.settings.privacy.default_visibility = 1">
          <div class="item-left">
            <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
              </svg>
            </div>
            <div class="item-text">
              <span class="main">Private (Only Me)</span>
              <span class="sub">This waypoint is private, It's only for your purpose.</span>
            </div>
          </div>
          <div class="radio-circle" [class.selected]="unitsData.settings.privacy.default_visibility == 1"></div>
        </div>

        <!-- Pier Circle -->
        <div class="privacy-item" [appTourAnchor]="'sharing.pierCircle'" (click)="unitsData.settings.privacy.default_visibility = 2">
          <div class="item-left">
            <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
              </svg>
            </div>
            <div class="item-text">
              <span class="main">Pier Circle (Dockmates and Fleets)</span>
              <span class="sub">Select specific followers or groups who can view this waypoint.</span>
            </div>
          </div>
          <div class="radio-circle" [class.selected]="unitsData.settings.privacy.default_visibility == 2"></div>
        </div>
      </div>

      <!-- Pier Circle Selection -->
      <div class="pier-circle-selection" *ngIf="unitsData.settings.privacy.default_visibility == 2">
        <div class="search-box">
          <img class="search-icon" src="assets/home/profile/searchicon.svg" alt="Search" />
          <input type="text" placeholder="Search Dockmates & Fleets" [(ngModel)]="sharingSearchQuery" />
        </div>

        <div class="selection-section">
          <label>Fleets</label>
          <div class="item-list">
            <div class="list-item" *ngFor="let fleet of filteredFleets">
              <div class="item-info">
                <div class="checkbox" [class.checked]="fleet.selected" (click)="fleet.selected = !fleet.selected">
                </div>
                <img *ngIf="fleet.image_url || fleet.image || fleet.logo_url"
                  [src]="fleet.image_url || fleet.image || fleet.logo_url" class="avatar" />
                <div *ngIf="!fleet.image_url && !fleet.image && !fleet.logo_url" class="avatar-fallback">
                  {{ getInitials(fleet.name) }}
                </div>
                <div class="info-text">
                  <span class="name">{{ fleet.name }}</span>
                  <span class="meta">{{ fleet.members_count || 0 }} members</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="selection-section">
          <label>Pier Circle</label>
          <div class="item-list">
            <div class="list-item" *ngFor="let mate of filteredDockmates">
              <div class="item-info">
                <div class="checkbox" [class.checked]="mate.selected" (click)="mate.selected = !mate.selected">
                </div>
                <img *ngIf="mate.user?.image_url" [src]="mate.user?.image_url" class="avatar" />
                <div *ngIf="!mate.user?.image_url" class="avatar-fallback">
                  {{ getInitials(mate.user?.name || mate.name) }}
                </div>
                <div class="info-text">
                  <span class="name">{{ mate.user?.name || mate.name }}</span>
                  <span class="meta">{{ mate.vessel_name || 'No Vessel' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div class="overlay-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
</div>

<!-- Password / Forgot Password Overlay -->
<div class="bottom-sheet-overlay security-overlay" *ngIf="showSecurityOverlay" (click)="toggleSecurityOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">

    <div class="header">
      <div class="header-actions">
        <app-back-button (clicked)="toggleSecurityOverlay(false)"></app-back-button>
        <h2 class="title">Forgot Password</h2>
        <app-confirm-button [appTourAnchor]="'password.send'" [loading]="isLoading" [disabled]="isLoading"
          (clicked)="requestPasswordReset()"></app-confirm-button>
      </div>
    </div>

    <div class="content-scrollable">
      <p class="content-text">
        We'll send password reset instructions to your registered email address.
      </p>

      <div class="forgot-email-display" [appTourAnchor]="'password.email'">
        <mat-icon class="forgot-email-icon">mail_outline</mat-icon>
        <div class="forgot-email-info">
          <span class="forgot-email-label">Email Address</span>
          <span class="forgot-email-value">{{ securityData.email || 'No email found' }}</span>
        </div>
      </div>

      <p class="forgot-spam-note">
        Check your spam folder if you don't receive the email within a few minutes.
      </p>
    </div>

    <div class="overlay-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
</div>

<!-- Support Overlay — mirrors the app's Contact Support sheet (support_sheet.dart) -->
<div class="bottom-sheet-overlay support-overlay" *ngIf="showSupportOverlay" (click)="toggleSupportOverlay(false)">
  <div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="header">
      <div class="header-actions">
        <app-back-button ariaLabel="Back to settings" (clicked)="toggleSupportOverlay(false)"></app-back-button>
        <h2 class="title">Contact Support</h2>
        <!-- Balances the back button, exactly like the app's nav bar. -->
        <span class="header-spacer" aria-hidden="true"></span>
      </div>
    </div>

    <div class="content-scrollable">
      <div class="support-form">
        <!-- Subject -->
        <p class="field-label">Subject (optional)</p>
        <div class="field-card" [appTourAnchor]="'support.subject'">
          <input type="text" [(ngModel)]="supportSubject" name="support_subject" placeholder="Brief summary"
            maxlength="120" />
        </div>

        <!-- Description -->
        <p class="field-label">Description</p>
        <div class="field-card" [appTourAnchor]="'support.description'">
          <textarea [(ngModel)]="supportMessage" name="support_message" rows="6"
            placeholder="Describe what happened…"></textarea>
        </div>

        <!-- Screenshots -->
        <p class="field-label">Screenshots (optional)</p>
        <button type="button" class="add-screenshots-btn" [appTourAnchor]="'support.screenshots'"
          (click)="screenshotInput.click()">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M19 3H5a2 2 0 0 0-2 2v9m0 0v0m0-9 0 14a2 2 0 0 0 2 2h9" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 16.5 8 12l4 3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M18 14v7m3.5-3.5h-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
          <span>Add Screenshots</span>
        </button>
        <input type="file" #screenshotInput hidden multiple accept="image/*"
          (change)="onSupportImagesSelected($event)" />

        <div class="screenshot-grid" *ngIf="supportImages.length">
          <div class="screenshot-thumb" *ngFor="let img of supportImages; let i = index">
            <img [src]="img.url" [alt]="img.file.name" />
            <button type="button" class="remove-thumb" aria-label="Remove screenshot"
              (click)="removeSupportImage(i)">&times;</button>
          </div>
        </div>

        <!-- Send -->
        <button type="button" class="send-support-btn" [appTourAnchor]="'support.send'" [disabled]="isSendingSupport"
          (click)="submitSupport()">
          <span class="btn-spinner" *ngIf="isSendingSupport"></span>
          <span *ngIf="!isSendingSupport">Send to Support</span>
        </button>
      </div>
    </div>
  </div>
</div>
